import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import MainLayout from "./layout/MainLayout";
import Login from "./view/login/index.jsx";
import Dashboard from "./view/Dashboard";
import UserList from "./view/users/UserList/index.jsx";
import UserDetail from "./view/users/UserDetail/index.jsx";
import NoticeList from "./view/notices/NoticeList";
import NoticeCreate from "./view/notices/NoticeCreate";
import NoticeDetail from "./view/notices/NoticeDetail";
import NoticeEdit from "./view/notices/NoticeEdit";
import FilterList from "./view/filters/FilterList";
import FilterCreate from "./view/filters/FilterCreate";
import FilterDetail from "./view/filters/FilterDetail";
import FilterEdit from "./view/filters/FilterEdit";
import Privacy from "./view/privacy";
import { NavigationProvider } from "./context/NavigationContext ";

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <main>
        <Router>
          <NavigationProvider>
            <Routes>
              {/* 인증 페이지 */}
              <Route path="/login" element={<Login />} />

              {/* 인증된 페이지들 (MainLayout 적용) */}
              <Route element={<MainLayout />}>
                {/* 대시보드 */}
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />

                {/* 회원 관리 */}
                <Route path="/users" element={<UserList />} />
                <Route path="/users/:userId" element={<UserDetail />} />

                {/* 공지사항 */}
                <Route path="/notices" element={<NoticeList />} />
                <Route path="/notices/create" element={<NoticeCreate />} />
                <Route path="/notices/:noticeId" element={<NoticeDetail />} />
                <Route path="/notices/:noticeId/edit" element={<NoticeEdit />} />

                {/* 최신 필터 */}
                <Route path="/filters" element={<FilterList />} />
                <Route path="/filters/create" element={<FilterCreate />} />
                <Route path="/filters/:newArrivalFilterId" element={<FilterDetail />} />
                <Route path="/filters/:newArrivalFilterId/edit" element={<FilterEdit />} />


                {/* 개인정보처리방침 */}
                <Route path="/privacy" element={<Privacy />} />

              </Route>
            </Routes>
          </NavigationProvider>
        </Router>
      </main>
    </div>
  );
}

export default App;